exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_gettingStated_YZAWQdWW3puXoORZ9yHsb {\n  position: relative;\n  width: 100%;\n  height: auto;\n  float: left;\n}\n\n.IA_video_2grnumDiUqf7oGC0l2L0Um {\n  position: relative;\n  float: left;\n  width: 300px;\n  height: 169px;\n  margin-right: 20px;\n  margin-bottom: 20px;\n}", ""]);

// Exports
exports.locals = {
	"IA_gettingStated": "IA_gettingStated_YZAWQdWW3puXoORZ9yHsb",
	"IA_video": "IA_video_2grnumDiUqf7oGC0l2L0Um"
};